import React from 'react';
import PropTypes from 'prop-types';
import './ErrorScreen.scss';

/**
 * Stateless component to draw a ErrorScreen.
 * @param {string} errorTitle error title.
 * @param {string} errorSubtitle Determine the errorSubtitle of the error.
 * @param {string} errorMessage Determine the message of the error.
 * @param {string} errorImage Determine the image of the error.
 * @param {string} errorAlt Detrmine the alt of image.
 * @param {string} errorLabelButton label of the button,emty label button not visible.
 * @returns {JSX} Component Period JSX.
 */

const ErrorScreen = ({
  wrapperClass,
  errorTitle,
  errorSubtitle,
  errorMessage,
  errorImage,
  errorAlt,
}) => {

  let fatalError = false;

  if (errorImage && errorImage.includes('fatalError')) {
    fatalError = true;
  }

  return (
    <div className={`errorScreen ${wrapperClass}`}>
      <div className="errorTitle">{errorTitle}</div>
      <div className="errorImage">
        {fatalError && (
          <div className="fatalError">
            Error Fatal
          </div>
        )}
        {!fatalError && errorImage && (
        <img
          className="imageError"
          src={errorImage}
          align="middle"
          alt={errorAlt}
          height="auto"
          width="160"
        />
        )}
      </div>
      {errorSubtitle && <div className="errorSubtitle">{errorSubtitle}</div>}
      {errorMessage && <div className="errorMessage">{errorMessage}</div>}
    </div>
  );
}

ErrorScreen.propTypes = {
  wrapperClass: PropTypes.string,
  errorTitle: PropTypes.string.isRequired,
  errorSubtitle: PropTypes.string,
  errorMessage: PropTypes.string,
  errorImage: PropTypes.string.isRequired,
  errorAlt: PropTypes.string.isRequired,
};
ErrorScreen.defaultProps = {
  wrapperClass: '',
  errorMessage: null,
  errorSubtitle: '',
}


export default ErrorScreen;
